import { Button, Image } from "antd";
import React from "react";

import "../../css/jobs.css";

import CompanyAvatar from "../../components/Avatars/CompanyAvatar";
import User from "../../assets/images/fi-rr-user.svg";
import { JOB_APPLICATION_STATUS } from "../../constants/stringConstants";

interface JobCompanyPropTypes {
  onApplyJob: React.MouseEventHandler<HTMLElement>;
  companyData: any;
  companyJobData: any;
  applicationStatus: string;
  isApplyBtnClicked:boolean
}

function JobCompany(props: JobCompanyPropTypes) {
  const { companyData, companyJobData, onApplyJob, applicationStatus,isApplyBtnClicked } = props;

  const getBtnColor = () => {
    if (
      applicationStatus == JOB_APPLICATION_STATUS.AWAITING ||
      applicationStatus === JOB_APPLICATION_STATUS.REVIEWED ||
      applicationStatus === JOB_APPLICATION_STATUS.SHORTLIST_CANDIDATE ||
      applicationStatus === JOB_APPLICATION_STATUS.HIRED ||
      applicationStatus === JOB_APPLICATION_STATUS.ON_HOLD ||
      applicationStatus === JOB_APPLICATION_STATUS.NOT_GOOD_FIT
    ) {
      return "grey";
    } else {
      return "blue";
    }
  };

  return (
    <div className="job_company_details">
      <div className="job_company_details_content">
        <div>
          {companyData.companyLogo ? (
            <Image
              src={companyData?.companyLogo}
              style={{ width: "40px", height: "40px" }}
            />
          ) : (
            <CompanyAvatar />
          )}
          <text>{companyData?.companyName}</text>
        </div>
        <div>
          <text>{companyJobData?.companyJob?.jobTitle}</text>
        </div>
        <div className="job_details_tile_container">
          <div className="job_details_tile">
            <img src={User} />
            <text style={{ marginLeft: "15px" }}>
              {" "}
              {companyJobData?.companyJob?.jobType}
            </text>
          </div>
          <div className="job_details_tile">
            <img src={User} />
            <text style={{ marginLeft: "15px" }}>
              {companyJobData?.companyJob?.workType}
            </text>
          </div>
          <div className="job_details_tile">
            <img src={User} />
            <text style={{ marginLeft: "15px" }}>
              {companyJobData?.professionalExperience}
            </text>
          </div>
        </div>
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          style={{
            width: "fit-content",
            paddingLeft: "35px",
            paddingRight: "35px",
            backgroundColor: getBtnColor(),
            color: "white",
          }}
          type="primary"
          htmlType="submit"
          onClick={onApplyJob}
          loading={isApplyBtnClicked}
          disabled={
            applicationStatus == JOB_APPLICATION_STATUS.AWAITING ||
            applicationStatus === JOB_APPLICATION_STATUS.REVIEWED ||
            applicationStatus === JOB_APPLICATION_STATUS.SHORTLIST_CANDIDATE ||
            applicationStatus === JOB_APPLICATION_STATUS.HIRED ||
            applicationStatus === JOB_APPLICATION_STATUS.ON_HOLD ||
            applicationStatus === JOB_APPLICATION_STATUS.NOT_GOOD_FIT ||
            isApplyBtnClicked
              ? true
              : false
          }
        >
          {applicationStatus == JOB_APPLICATION_STATUS.AWAITING
            ? "You’ve already applied for this job"
            : applicationStatus === JOB_APPLICATION_STATUS.REVIEWED
            ? "Your application is under review"
            : applicationStatus === JOB_APPLICATION_STATUS.SHORTLIST_CANDIDATE
            ? "You are shortlisted"
            : applicationStatus === JOB_APPLICATION_STATUS.HIRED
            ? "You are hired for this job"
            : applicationStatus === JOB_APPLICATION_STATUS.ON_HOLD
            ? "You are on hold for this job"
            : applicationStatus === JOB_APPLICATION_STATUS.NOT_GOOD_FIT
            ? "You are not a good fit for this job"
            : "Apply"}
        </Button>
      </div>
    </div>
  );
}

export default JobCompany;
